const translations = {
    downloadLink: 'Download Invoice PDF'
};

export default translations;
